module.exports = __webpack_public_path__ + "a5f51421bbb16742b2b5724fae4f3012.webp";